<template>
  <section class="section">
      <div class="container">
        <h1 class="admin-page">Histórico de Entregas</h1>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3">
            <div class="box-aside line-top smart-form">
              <div class="box-header-lg">
                <i class="icon-filter"></i><h1> FILTROS</h1>
              </div>
              <div class="box-aside-body box-aside-filters">
                <div class="form-group">
                  <label>EMPRESA</label>
                  <br/>
                  <select class="form-control select2 filter-select2" ref="slEmpresa" multiple style="z-index:1000; width:100%!important; max-width:100%;" data-select2-container="big-text">
                    <option v-for="empresa in empresas" :key="empresa._id" :value="empresa._id">{{empresa.empresa.razonSocial}} - {{empresa.denominacion}}</option>
                  </select>                
                  <a @click="quitarFiltrosEmpresa" class="disable-filter" :class="{show: filtros.empresas.length > 0}">Quitar filtro empresa</a>
                </div>
                <div class="form-group">
                  <label>EMPLEADO</label>
                  <br/>                  
                  <select class="form-control select2 filter-select2" ref="slUsuario" multiple style="width:100%" data-select2-container="big-text">
                    <option v-for="usuario in usuariosDistinct" :key="usuario._id" :value="usuario._id">{{usuario.displayName}}</option>
                  </select>
                  <a @click="quitarFiltrosEmpleado" class="disable-filter" :class="{show: filtros.empleados.length > 0}">Quitar filtro empleado</a>
                </div>
                <div class="form-group">
                  <label>DESDE</label>
                  <date-picker ref="pickerDesde" v-model="filtros.desde" :max-date="new Date()"></date-picker>
                  <!-- agregar class "show" para mostrar el link quitar filtro-->
                  <a href="#" class="disable-filter">Quitar filtro fecha</a>
                </div>
                <div class="form-group">
                  <label>HASTA</label>
                  <date-picker ref="pickerHasta" v-model="filtros.hasta" :max-date="new Date()"></date-picker>
                  <!-- agregar class "show" para mostrar el link quitar filtro-->
                  <a href="#" class="disable-filter">Quitar filtro fecha</a>
                </div>
                <div class="form-group">
                  <label>ESTADO</label>
                  <div class="select">
                    <select class="form-control" v-model="filtros.estado">
                      <option value="-1">Todos</option>
                      <option>Recibido</option>
                      <option>Cocina</option>
                      <option>Empaquetado</option>
                      <option>Despachado</option>
                      <option>Entregado</option>   
                      <option>Cancelado</option>
                    </select>
                    <i class="fa fa fa-angle-down"></i>
                  </div>
                </div>
              </div> 
            </div>
            <div class="clear-sm"></div>
            <div class="box-aside line-top smart-form">
              <div class="box-header-lg">
                <i class="icon-stats"></i><h1> RESUMEN</h1>
              </div>
              <div class="box-aside-body resume stats">
                <div class="stats-item">
                  <div class="row">
                    <div class="col-xs-4">
                      <span class="stats-number process">{{contadores['Recibido']}}</span>
                    </div>
                    <div class="col-xs-8">
                      <span class="stats-label">Recibidos</span>
                    </div>
                  </div>
                </div>
                <div class="stats-item">
                  <div class="row">
                    <div class="col-xs-4">
                      <span class="stats-number payment-pending">{{contadores['Cocina']}}</span>
                    </div>
                    <div class="col-xs-8">
                      <span class="stats-label">En Cocina</span>
                    </div>
                  </div>
                </div>
                <div class="stats-item">
                  <div class="row">
                    <div class="col-xs-4">
                      <span class="stats-number oncourse">{{contadores['Empaquetado']}}</span>
                    </div>
                    <div class="col-xs-8">
                      <span class="stats-label">Empaquetados</span>
                    </div>
                  </div>
                </div>
                <div class="stats-item">
                  <div class="row">
                    <div class="col-xs-4">
                      <span class="stats-number payment-closed">{{contadores['Despachado']}}</span>
                    </div>
                    <div class="col-xs-8">
                      <span class="stats-label">Despachados</span>
                    </div>
                  </div>
                </div>
                <div class="stats-item">
                  <div class="row">
                    <div class="col-xs-4">
                      <span class="stats-number pending">{{contadores['Cancelado']}}</span>
                    </div>
                    <div class="col-xs-8">
                      <span class="stats-label">Cancelados</span>
                    </div>
                  </div>
                </div>

              </div> 
              <div class="box-aside-body resume-total">
                <h3 class="total-number">{{contadores['Monto'] | formatMoneda}}</h3>
                <span class="total-label">Total de los días filtrados</span>
              </div>
            </div>
            <div class="clear-sm"></div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-8 col-lg-9">
            <div class="box-style line-top smart-form">
              <div class="box-header-lg">
                <h1 class="filter-breadcrumb"> <span class="semibold">FILTROS</span> <i class="fa fa-angle-right"></i> 
                    <span v-if="filtros.desde"> del <span class="regular">{{moment(filtros.desde).format("DD/MM/YYYY")}}</span></span>
                    <span v-if="filtros.hasta"> al <span class="regular">{{moment(filtros.hasta).format("DD/MM/YYYY")}}</span></span>
                    <span v-if="filtros.hasta||filtros.desde">|</span> 
                </h1>
                <div class="box-header-aside">
                  <a @click="limpiarFiltros()" v-if="filtros.desde||filtros.hasta||filtros.empresas.length>0||filtros.empleados.length>0||filtros.estado" class="quit-filter"><i class="icon-close"></i> Quitar filtros</a>
                </div>
              </div>
              <div class="panel-body">
                <div class="table-header form smart-form">
                  <div class="form-group col-hactions">
                    <label class="label-lg"><i class="icon-export"></i> Descargar</label>
                    <div class="col-action">
                      <div class="btn-group">
                        <button class="btn btn-outline-grey-green" @click="exportXls()">
                          EXCEL
                        </button>
                      </div>
                      <div class="btn-group">
                        <button class="btn btn-outline-grey-green" @click="exportPdf()">
                           PDF
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel-group smart-accordion-default" id="accordion">
                <div class="panel panel-time" v-for="entregasFecha, idx, a in entregasAgrupadas" :key="entregasFecha">
                  <div class="panel-heading">
                    <div class="panel-title box-header">
                      <a data-toggle="collapse" :href="'#panel' + a">
                        <i class="fa fa-lg fa-angle-down pull-right"></i>
                        <i class="fa fa-lg fa-angle-up pull-right"></i>
                        <h2><b>{{idx}}</b></h2>
                      </a>
                    </div>
                  </div>
                  <div :id="'panel' + a" class="panel-collapse collapse in">
                    <div class="panel-body">
                      <div class="table-container">
                        <table class="table table-hover table-stripped table-no-first-pad table-manager-time">
                          <thead>
                            <tr>                              
                              <th>Nro.</th>
                              <th>Hora</th>
                              <th>Usuario</th>
                              <th>Empresa</th>
                              <th>Menú</th>
                              <th>Estado</th>
                              <th></th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="entrega in entregasFecha" :key="entrega._id">
                              <td>{{entrega.numero}}</td>
                              <td>{{entrega.horaEntrega}}hs</td>
                              <td>{{entrega.usuario.displayName}}</td>
                              <td>{{entrega.sucursal.empresa.razonSocial}}-{{entrega.sucursal.denominacion}}</td>
                              <td><span class="truncate">{{entrega.platosSerialized}}</span></td>
                              <td class="td-status">
                                {{entrega.estado}}
                              </td>
                              <td>
                                <!--
                                <ul class="table-actions smart-form">
                                  <li>
                                    <a href="javascript:void(0)" class="btn btn-xs btn-ghost" type="button" rel="tooltip" data-placement="top" data-original-title="Exportar en Excel">
                                      <i class="fa fa-actions fa-file-excel-o"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a href="javascript:void(0)" class="btn btn-xs btn-ghost" type="button" rel="tooltip" data-placement="top" data-original-title="Exportar en PDF">
                                      <i class="fa fa-actions fa-file-pdf-o"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a href="javascript:void(0)" class="btn btn-xs btn-ghost" type="button" rel="tooltip" data-placement="top" data-original-title="Imprimir comanda">
                                      <i class="fa fa-actions fa-print"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a href="javascript:void(0)" class="btn btn-xs btn-ghost" type="button" rel="tooltip" data-placement="top" data-original-title="Imprimir etiqueta">
                                      <i class="fa fa-actions fa-ticket"></i>
                                    </a>
                                  </li>
                                </ul>
                                -->
                              </td>
                              <td>
                                <a @click="abrirComanda(entrega)" type="button" class="btn btn-outline btn-xsw pull-right">DETALLE</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    <div class="modal fade detalle-pedido" id="detalle-pedido" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document" v-if="entregaComanda">
      <div class="modal-content">
        <div class="modal-body" >
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h2>Comanda #{{entregaComanda.numero}}</h2>
        <p class="size-16">
          Fecha y hora: <span class="semibold">{{entregaComanda.fechaEntrega | fechaComanda}}</span><br/>
          Empresa: <span class="semibold">{{ entregaComanda.sucursal.empresa.razonSocial }} - {{ entregaComanda.sucursal.denominacion }}</span><br/>
          Empleado: <span class="semibold">{{entregaComanda.usuario.displayName}}</span><br/>
          <span class="deliveryModalRestrictions" v-if="entregaComanda.usuario.other||entregaComanda.usuario.alergic||entregaComanda.usuario.vegan||entregaComanda.usuario.vegetarian">
            <h4>TIENE RESTRICCIONES ALIMENTICIAS</h4>
            <span class="text-danger" v-if="entregaComanda.usuario.vegan"><i class="icon-vegan"></i> Vegano</span>
            <span class="text-danger" v-if="entregaComanda.usuario.vegetarian"><i class="icon-vegetarian"></i> Vegetariano</span>
            <span class="text-danger" v-if="entregaComanda.usuario.celiac"><i class="icon-celiac"></i> Sin gluten</span>
            <span class="text-danger" v-if="entregaComanda.usuario.other"><i class="icon-menu-config"></i> Otros</span>
            <span class="text-danger" v-if="entregaComanda.usuario.alergic"><i class="icon-spice"></i> Alérgico</span>
            <br/>
            <br/>
            <span class="text-danger" v-if="entregaComanda.usuario.other||entregaComanda.usuario.alergic">
              {{entregaComanda.usuario.restrictions}}
            </span>
          </span>
        </p>
        <ul class="order-list">
          <li v-for="plato in entregaComanda.platos" :key="plato._id"><span>{{plato.cantidad}}x</span> {{plato.plato.nombre}}</li>
        </ul>
      
        </div>
      </div>
      </div>
    </div><!-- Fin modal comanda-->
    <div class="hidden" ref="contenedorExport"></div>    
  </section><!-- Fin contenedor histórico de entregas -->
    <!-- Modal comanda -->
</template>
<script>
import '../../assets/css/admin.css'
import '../../assets/css/select2_status.css'
import '../../assets/css/select2.css'
import $ from 'jquery'
import 'select2'
import moment from 'moment'
import DatePicker from '../Shared/DatePicker'
import _ from 'lodash'
import '../../assets/css/jquery-ui.min.css'
import '../../assets/js/jquery-ui.min.js'
import JsPDF from 'jspdf'
import 'jspdf-autotable'
import TableExport from 'tableexport'

export default {
  components: {
    'date-picker': DatePicker
  },
  data () {
    return {
      entregas: [],
      entregaComanda: null,
      empresas: [],
      filtros: {
        desde: null,
        estado: null,
        hasta: null,
        empresas: [],
        empleados: []
      }
    }
  },
  computed: {
    contadores () {
      let contadores = {'Recibido': 0, 'Cocina': 0, 'Empaquetado': 0, 'Despachado': 0, 'Entregado': 0, 'Cancelado': 0, 'Monto': 0}
      const me = this
      me.entregasFiltradas.map(entrega => {
        contadores[entrega.estado]++
        contadores['Monto'] += entrega.montoTotal
      })
      return contadores
    },
    entregasFiltradas () {
      const me = this
      let entregas = me.entregas
      if (me.filtros.desde) {
        entregas = entregas.filter((entrega) => {
          return new Date(entrega.fechaEntrega) >= moment(me.filtros.desde).startOf('day').toDate()
        })
      }
      if (me.filtros.hasta) {
        entregas = entregas.filter((entrega) => {
          return new Date(entrega.fechaEntrega) < moment(me.filtros.hasta).endOf('day').toDate()
        })
      }
      if (me.filtros.estado && me.filtros.estado !== '-1') {
        entregas = entregas.filter((entrega) => {
          return entrega.estado === me.filtros.estado
        })
      }
      if (me.filtros.empresas.length > 0) {
        entregas = entregas.filter((entrega) => {
          return me.filtros.empresas.includes(entrega.sucursal._id)
        })
      }
      if (me.filtros.empleados.length > 0) {
        entregas = entregas.filter((entrega) => {
          return me.filtros.empleados.includes(entrega.usuario._id)
        })
      }
      return entregas
    },
    entregasAgrupadas () {
      const me = this
      return _.groupBy(me.entregasFiltradas, (entrega) => {
        return entrega.fechaFormateada
      })
    },
    empresasDistict () {
      const me = this
      if (me.usuariosDistinct.length < 1) return []
      let empresas = me.entregas.map((entrega) => {
        return {
          _id: entrega.sucursal._id,
          desc: entrega.sucursal.empresa.razonSocial + '-' + entrega.sucursal.denominacion
        }
      })
      let empresasDistict = _.uniqBy(empresas, (empresa) => {
        return empresa._id
      })
      console.log(empresasDistict)
      return _.sortBy(empresasDistict, 'desc')
    },
    usuariosDistinct () {
      const me = this

      let usuarios = me.entregas.map((entrega) => {
        if (me.filtros.empresas.length > 0) {
          let esDeLaEmpresa = me.filtros.empresas.includes(entrega.sucursal._id)
          if (esDeLaEmpresa) return entrega.usuario
        } else {
          return entrega.usuario
        }
      })

      usuarios = _.without(usuarios, undefined)

      let usuariosDistinct = _.uniqBy(usuarios, (usuario) => {
        console.log(usuario)
        return usuario._id
      })
      return _.sortBy(usuariosDistinct, 'displayName')
    }
  },
  methods: {
    exportXls (entregas, nombreArchivo) {
      const me = this
      let title = 'Entregas'

      if (me.filtros.desde) {
        title += ' desde el ' + moment(me.filtros.desde).format('DD/MM/YYYY')
      }
      if (me.filtros.hasta) {
        title += ' al ' + moment(me.filtros.hasta).format('DD/MM/YYYY')
      }
      title += ' | '
      title += ' Estado: '
      me.filtros.estado === null ? title += 'Todos' : title += me.filtros.estado

      if (me.filtros.empresas.length > 0) {
        title += ' | '
        let empresasSeleccionadas = []
        me.empresasDistict.map(empresa => {
          if (me.filtros.empresas.includes(empresa._id)) {
            empresasSeleccionadas.push(empresa.desc)
          }
        })
        title += empresasSeleccionadas.join(', ')
      } else {
        title += ' | Todas las Empresas'
      }
      let html = `<table class="table" id="tblExport">
        <thead>
          <tr>
            <th colspan='6'>${title}</th>
          </tr>
          <tr>
            <th>Fecha</th>
            <th>Usuario</th>
            <th>Numero</th>
            <th>Menu</th>
            <th>Restricciones</th>
            <th>Empresa</th>
          </tr>
        </thead>
        <tbody>
          ${me.entregasFiltradas.map(entrega => {
            let restrictions = []
            entrega.usuario.celiac ? restrictions.push('Sin gluten') : null
            entrega.usuario.vegan ? restrictions.push('Vegano') : null
            entrega.usuario.vegetarian ? restrictions.push('Vegetariano') : null
            entrega.usuario.other ? restrictions.push('Otras') : null
            entrega.usuario.alergic ? restrictions.push('Alérgico') : null
            entrega.usuario.other || entrega.usuario.alergic ? restrictions.push(entrega.usuario.restrictions) : null
            return `<tr>
              <td>${entrega.fechaEntrega}</td>
              <td>${entrega.usuario.displayName}</td>
              <td>${entrega.numero}</td>
              <td>${entrega.platosSerialized}</td>
              <td>${restrictions.join(', ')}</td>
              <td>${entrega.sucursal.empresa.razonSocial}-${entrega.sucursal.denominacion}</td>
            </tr>`
          })
            }
        </tbody>
      </table>`
      $(me.$refs.contenedorExport).html(html)
      let table = document.getElementById('tblExport')
      let tableExp = new TableExport(table, {
        exportButtons: false,
        formats: ['xls', 'csv', 'txt', 'xlsx']
      })
      tableExp.types.date.assert = function (v) {
        return false
      }
      let exportData = tableExp.getExportData()
      tableExp.export2file(exportData.tblExport.xlsx.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'historialEntregas', '.xlsx')
      // console.log(exportData.xls)
    },
    exportPdf () {
      const me = this
      var img = new Image()
      img.src = '/images/bird.png'
      img.onload = function () {
        let title = 'Entregas '
        if (me.filtros.desde) {
          title += ' desde el ' + moment(me.filtros.desde).format('DD/MM/YYYY')
        }
        if (me.filtros.hasta) {
          title += ' al ' + moment(me.filtros.hasta).format('DD/MM/YYYY')
        }
        if (me.filtros.desde || me.filtros.hasta) {
          title += ' | '
        }
        title += ' Estado: '
        me.filtros.estado === null ? title += 'Todos' : title += me.filtros.estado
        const columns = ['Fecha', 'Usuario', 'Numero', 'Menu', 'Restricciones', 'Empresa']
        const rows = me.entregasFiltradas.map((entrega) => {
          let restrictions = []
          entrega.usuario.celiac ? restrictions.push('Sin gluten') : null
          entrega.usuario.vegan ? restrictions.push('Vegano') : null
          entrega.usuario.vegetarian ? restrictions.push('Vegetariano') : null
          entrega.usuario.other ? restrictions.push('Otras') : null
          entrega.usuario.alergic ? restrictions.push('Alérgico') : null
          entrega.usuario.other || entrega.usuario.alergic ? restrictions.push(entrega.usuario.restrictions) : null
          return [
            entrega.fechaFormateada,
            entrega.usuario.displayName,
            entrega.numero,
            entrega.platosSerialized,
            restrictions.join(', '),
            entrega.sucursal.empresa.razonSocial + ' ' + entrega.sucursal.denominacion
          ]
        })
        const doc = new JsPDF('l')
        doc.autoTable(columns, rows, {
          margin: 25,
          bodyStyles: {
            overflow: 'visible',
            fontSize: 8,
            columnWidth: 'wrap'
          },
          headerStyles: {
            fillColor: [147, 165, 18]
          },
          addPageContent: function (data) {
            doc.addImage(img, 'PNG', 25, 10, 12, 12)
            doc.setFontSize(12)
            doc.text(title, 40, 18)
          }
        })
        doc.save('historicoEntregas.pdf')
      }
    },
    limpiarFiltros () {
      const me = this
      me.$refs.pickerDesde._data.flatpickr.clear()
      me.$refs.pickerHasta._data.flatpickr.clear()
      me.filtros.desde = null
      me.filtros.hasta = null
      me.filtros.empresas = []
      me.filtros.empleados = []
      me.filtros.estado = null
      me.filtros.estado = '-1'
      $(me.$refs.slUsuario).val(me.filtros.empleados).trigger('change')
      $(me.$refs.slEmpresa).val(me.filtros.empresas).trigger('change')
      return true
    },
    abrirComanda (entrega) {
      const me = this
      me.entregaComanda = entrega
      $('#detalle-pedido').modal()
    },
    formatSelect (itemstatus) {
      if (!itemstatus.id) return itemstatus.text
      return '<span class="highlight-status status-' + itemstatus.id.toLowerCase() + '">' + itemstatus.text + '</span>'
    },
    quitarFiltrosEmpleado () {
      const me = this
      me.filtros.empleados = []
      $(me.$refs.slUsuario).val(me.filtros.empleados).trigger('change')
    },
    quitarFiltrosEmpresa () {
      const me = this
      me.filtros.empresas = []
      $(me.$refs.slEmpresa).val(me.filtros.empresas).trigger('change')
    }
  },
  filters: {
    fechaFormateada (value) {
      return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
    },
    formatMoneda (value) {
      return '$ ' + parseFloat(value).toFixed(2)
    },
    lower (value) {
      return `status-${value.trim().toLowerCase()}`
    }
  },
  mounted () {
    const me = this
    me.moment = moment
    $('body').addClass('admin')
    me.$http.get('/api/restaurante/getentregasfechas').then(({body}) => {
      body.entregas.forEach((entrega) => {
        let platosArray = entrega.platos.map((plato) => {
          return `${plato.cantidad}x ${plato.plato.nombre}`
        })
        entrega.platosSerialized = platosArray.join(', ')
        entrega.seleccionada = false
        entrega.fechaFormateada = moment(entrega.fechaEntrega).format('DD/MM/YYYY')
      })
      me.entregas = body.entregas
      me.empresas = body.sucursales
      console.info(me.entregas)
    }, (err) => {
      console.error(err)
    }).then(() => {
      $(me.$refs.slEmpresa).select2({
        placeholder: 'Seleccione una empresa'
      }).on('change', (e) => {
        me.filtros.empresas = $(me.$refs.slEmpresa).val()
      })
      $(me.$refs.slUsuario).select2({
        placeholder: 'Seleccione un usuario'
      }).on('change', (e) => {
        me.filtros.empleados = $(me.$refs.slUsuario).val()
      })
      $.datepicker.setDefaults($.datepicker.regional['es'])
      $('.datepicker.desde').datepicker({
        dateFormat: 'dd/mm/yy',
        beforeShowDay: $.datepicker.noWeekends
      }).datepicker('setDate', moment().add(-30, 'days').toDate())
      $('.datepicker.hasta').datepicker({
        dateFormat: 'dd/mm/yy',
        beforeShowDay: $.datepicker.noWeekends
      }).datepicker('setDate', moment().add(-1, 'days').toDate())
    })
  },
  destroyed () {
    $('body').removeClass('admin')
  }
}
</script>
<style scoped>
  .panel-title.box-header {
    padding: 7px;
  }
  span.selection {
    height: 30px;
  }
</style>



// WEBPACK FOOTER //
// HistoricoEntregas.vue?3e5066d5